/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import LeftPanel from "../../../components/LeftPanel";
import Header from "../../../components/Header";
import axios from "axios";
import DatePicker from "react-datepicker";
import { Search } from "@mui/icons-material";
import Context from "../../../context/context";
import JsPDF from "jspdf";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
let DEFAULT_DATA = [];
// const server = 'http://localhost:5000'
const server = "https://api.myfooddo.com";
const fileExtension = ".xlsx";
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const generateDate = (date = Date.now()) =>
  sessionStorage
    .getItem("date_format")
    ?.replace(
      "mm",
      ("00" + (new Date(date)?.getMonth() + 1)?.toString())?.slice(-2)
    )
    ?.replace(
      "yy",
      ("0000" + new Date(date)?.getFullYear()?.toString())?.slice(-4)
    )
    ?.replace("dd", ("00" + new Date(date)?.getDate()?.toString())?.slice(-2));

const ItemReports = () => {
  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(
      Date.UTC(
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getFullYear()
          .toString(),
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getMonth()
          .toString(),
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getDate()
          .toString(),
        "00",
        "00",
        "00"
      )
    ).getTime()
  );
  const [endDate, setEndDate] = useState(
    new Date(
      Date.UTC(
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getFullYear()
          .toString(),
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getMonth()
          .toString(),
        new Date(parseFloat(localStorage.getItem("current-working-day")))
          ?.getDate()
          .toString(),
        "00",
        "00",
        "00"
      )
    ).getTime()
  );
  const [itemsDetails, setItemsDetails] = useState([]);
  const context = useContext(Context);
  const { setUnAuthPopup } = context;
  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || [];

  const onSearch = async () => {
    let timeDifference =
      new Date(
        parseFloat(localStorage.getItem("current-working-day"))
      ).getDate() - new Date(startDate).getDate();
    if (
      restrictions.length &&
      (parseInt(restrictions[0]?.other_report_item_sale) || 0) < timeDifference
    ) {
      setUnAuthPopup(true);
      setTimeout(() => setUnAuthPopup(false), 3000);
      return;
    }
    const result = await axios({
      url: `${server}/order/getItemsSalesDetails`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: [
        {
          start_date: startDate,
          end_date: endDate,
          outlet_uuid: localStorage.getItem("outlet_uuid"),
        },
      ],
    });

    console.log(result.data.result);
    setItemsDetails(result.data.result);
    DEFAULT_DATA = result.data.result;
  };

  const printDocument = () => {
    const report = new JsPDF("landscape", "pt", "a4");
    report.html(document.getElementById("xlsTableToPrint")).then(() => {
      report.save("report.pdf");
    });
  };

  const [searchbar, setSearchBar] = useState("");
  const searchbarInputHandler = (e) => {
    setSearchBar(e.target.value);
    let input = e.target.value?.toLowerCase();

    if (input)
      setItemsDetails(
        DEFAULT_DATA.filter(
          (i) =>
            i.item_name?.toLowerCase().includes(input) ||
            i.category_name?.toLowerCase().includes(input)
        )
      );
    else setItemsDetails(DEFAULT_DATA);

    console.log(DEFAULT_DATA);
  };

  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
      />
      <Header />
      <div className="item-sales-container orders-report-container">
        <div id="heading">
          <h2>Items Sales Report</h2>
        </div>
        <div id="item-sales-top">
          <div id="date-input-container" style={{ overflow: "visible" }}>
            <label htmlFor="date-from">
              From date
              <DatePicker
                id="date-from"
                selected={startDate}
                dateFormat={sessionStorage
                  .getItem("date_format")
                  ?.replace(/mm/, "MM")}
                maxDate={new Date()}
                onChange={(date) => {
                  setStartDate(
                    new Date(
                      Date.UTC(
                        new Date(date)?.getFullYear().toString(),
                        new Date(date)?.getMonth().toString(),
                        new Date(date)?.getDate().toString(),
                        "00",
                        "00",
                        "00"
                      )
                    ).getTime()
                  );
                }}
                className="date-picker test"
                wrapperClassName=""
                shouldCloseOnSelect={true}
              />
            </label>
            <label>
              To date
              <DatePicker
                id="date-to"
                selected={endDate}
                dateFormat={sessionStorage
                  .getItem("date_format")
                  ?.replace(/mm/, "MM")}
                maxDate={new Date()}
                onChange={(date) => {
                  setEndDate(
                    new Date(
                      Date.UTC(
                        new Date(date)?.getFullYear().toString(),
                        new Date(date)?.getMonth().toString(),
                        new Date(date)?.getDate().toString(),
                        "00",
                        "00",
                        "00"
                      )
                    ).getTime()
                  );
                }}
                className="date-picker test"
                wrapperClassName=""
                shouldCloseOnSelect={true}
              />
            </label>
            <button className="item-sales-search" onClick={onSearch}>
              <Search style={{ fontSize: "21px" }} /> Search
            </button>
          </div>
          <input
            type="text"
            id="item-sales-searchbar"
            placeholder="Type to filter Category and Items"
            value={searchbar}
            onChange={searchbarInputHandler}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "60px",
              marginRight: "10px",
            }}
          >
            <ReactHTMLTableToExcel
              className="hoverIcons"
              style={{ cursor: "pointer" }}
              table="xlsTableToPrint"
              sheet="Sheet"
              filename="items-sales-report"
              buttonText="Excel"
            />
            <button
              className="hoverIcons"
              onClick={printDocument}
              style={{ cursor: "pointer" }}
            >
              PDF
            </button>
          </div>
        </div>
        <div className="table-container-user item-sales-container">
          <Table
            itemsDetails={itemsDetails}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>
      <div style={{ display: "none" }}>
        <table id="xlsTableToPrint">
          <thead id="tableHeadToPrint">
            <tr>
              <th colSpan={5} style={{ fontSize: "x-large" }}>
                {localStorage.getItem("outlet-name")}
              </th>
            </tr>
            <tr>
              <th colSpan={2}>From : {generateDate(startDate)}</th>
              <th></th>
              <th colSpan={2}>To :{generateDate(endDate)}</th>
            </tr>
            <tr>
              <th>S.N</th>
              <th>Category</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody id="tableBodyToPrint" style={{ border: " solid black" }}>
            {itemsDetails?.map((item, i) => (
              <tr key={Math.random()}>
                <td>{i + 1}</td>
                <td>{item.category_name}</td>
                <td>{item.item_name}</td>
                <td>{item.qty}</td>
                <td>{item.type}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={5}></td>
            </tr>
            <tr>
              <td colSpan={5}>
                Generated using FoodDo at {generateDate()}{" "}
                {new Date().toLocaleTimeString(navigator.language, {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ItemReports;

function Table({ itemsDetails, ...props }) {
  const [statementPopUpState, setStatementPopUpState] = useState(null);
  return (
    <>
      <table
        className="user-table"
        style={{ maxWidth: "100vw", overflowX: "scroll" }}
      >
        <thead>
          <tr>
            <th>S.N</th>
            <th>Category</th>
            <th>Item</th>
            <th>Qty</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {itemsDetails?.map((item, i) => (
            <tr key={Math.random()}>
              <td>{i + 1}</td>
              <td>{item.category_name}</td>
              <td>{item.item_name}</td>
              <td
                style={{ color: "blue", textDecoration: "underline" }}
                onClick={() => setStatementPopUpState(item.item_uuid)}
              >
                {item.qty}
              </td>
              <td>{item.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {statementPopUpState ? (
        <CustomerPaymentPopup
          item={itemsDetails?.find((i) => i.item_uuid === statementPopUpState)}
          close={() => setStatementPopUpState(null)}
          {...props}
        />
      ) : (
        ""
      )}
    </>
  );
}

const CustomerPaymentPopup = ({ close, startDate, endDate, item }) => {
  const { item_uuid, item_name } = item;
  const [itemData, setItemData] = useState(null);

  const callApi = async () => {
    const url = `${server}/order/order-item-detail`;
    let res = await fetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_uuid,
        date_range: { startDate, endDate },
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }),
    });

    if (res.ok) {
      res = await res.json();
      console.log(res);
      setItemData(res.items);
    }
  };

  const getDataFormIDB = async () => {
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let store = db.transaction("Orders", "readonly").objectStore("Orders");
    const orders = await store.getAll();
    const items = [];
    orders
      ?.filter((i) => +i.working_day >= startDate && +i.working_day <= endDate)
      ?.forEach((order) =>
        order.order_kot_details.forEach((kot) =>
          kot.kot_items_details.forEach((item) => {
            if (item.item_uuid === item_uuid) {
              items.push({
                item_qty: item.order_item_qty,
                order_date: order.working_day,
                order_number: order.local_order_id,
                amount: item.order_item_amount_inclusive_taxes,
              });
            }
          })
        )
      );
    console.log(items);
    setItemData(items);
  };

  useEffect(() => {
    const dates_json = JSON.parse(localStorage.getItem("dates_json"));
    if (
      dates_json.find((i) => +i.date === +startDate) &&
      dates_json.find((i) => +i.date === +endDate)
    )
      getDataFormIDB();
    else callApi();
  }, []);
  const downloadHandler = async () => {
    let sheetData = itemData.map((a) => {
      // console.log(a)
      return {
        "Order Date": generateDate(+a.order_date) || "",
        "Local Order Number": a.order_number || "",
        Quantity: a.item_qty || "",
        Amount: a.amount || "",
      };
    });
    // console.log(sheetData)

    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "ItemReport" + fileExtension);
  };
  return (
    <div className="newCategory">
      <div
        className="newCatContainer"
        style={{
          width: "fit-content",
          height: "fit-content",
          minHeight: "500px",
        }}
      >
        <div className="newCatContainer_header">
          <h2>{item_name}</h2>
          <XIcon className="closeicon" onClick={close} />
        </div>
        <div
          className="newCatContainer2"
          style={{ height: "fit-content", width: "fit-content" }}
        >
          <h2>Statement</h2>
          <button
            onClick={downloadHandler}
            className="item-sales-search"
            style={{
              position: "absolute",
              top: "50px",
              left: "10px",
              padding: "10px",
              fontSize: "15px",
            }}
          >
            XLS
          </button>
          <div
            style={{
              display: "flex",
              width: "500px",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "200px",
                padding: "10px 0",
                alignItems: "left",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <label htmlFor="date-from" style={{ width: "100%" }}>
                From date
              </label>
              <DatePicker
                id="date-from"
                selected={startDate || Date.now()}
                dateFormat={sessionStorage
                  .getItem("date_format")
                  ?.replace(/mm/, "MM")}
                maxDate={new Date()}
                className="date-picker test"
                wrapperClassName=""
                shouldCloseOnSelect={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "200px",
                padding: "10px 0",
                alignItems: "left",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <label style={{ width: "100%" }}>To date</label>
              <DatePicker
                id="date-to"
                selected={endDate || Date.now()}
                dateFormat={sessionStorage
                  .getItem("date_format")
                  ?.replace(/mm/, "MM")}
                maxDate={new Date()}
                className="date-picker test"
                wrapperClassName=""
                shouldCloseOnSelect={true}
              />
            </div>
          </div>
          <div className="itemavilablelitybox" style={{ width: "100%" }}>
            <div className="items_table" style={{ width: "100%" }}>
              <table className="f6 w-100 center" cellSpacing="0">
                <thead className="lh-copy">
                  <tr className="white">
                    <th className="pa3 bb b--black-20 tl">S.NO.</th>
                    <th className="pa3 bb b--black-20 tl">Order Date</th>
                    <th className="pa3 bb b--black-20 tl">Local Order Number</th>
                    <th className="pa3 bb b--black-20 tl">Quantity</th>
                    <th className="pa3 bb b--black-20 tl">Amount</th>
                  </tr>
                </thead>
                <tbody className="lh-copy">
                  {itemData?.map((item, i) => (
                    <tr>
                      <td
                        className="ph3 bb b--black-20 tc bg-white"
                        style={{ padding: "10px" }}
                      >
                        {i + 1}
                      </td>
                      <td
                        className="ph3 bb b--black-20 tc bg-white"
                        style={{ padding: "10px" }}
                      >
                        {generateDate(+item.order_date)}
                      </td>
                      <td
                        className="ph3 bb b--black-20 tc bg-white"
                        style={{ padding: "10px" }}
                      >
                        {item.order_number}
                      </td>
                      <td
                        className="ph3 bb b--black-20 tc bg-white"
                        style={{ padding: "10px" }}
                      >
                        {item.item_qty}
                      </td>
                      <td
                        className="ph3 bb b--black-20 tc bg-white"
                        style={{ padding: "10px" }}
                      >
                        Rs.{(+item.amount)?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
